import { usePremiumFeatureAllowed } from 'shared/hooks/use-premium-feature-allowed';
import { useUser } from 'shared/hooks/use-user';
import { LimitKeys } from 'shared/types/limit-keys';
import { CalendarViewOptions } from 'shared/types/upcoming-view-options';

export const useSelectedCalendarView = () => {
  const user = useUser();
  const userSelectedView =
    user?.settings?.upcoming?.webCalendarView ?? CalendarViewOptions.Week;

  const { allowed: isCalendarFourDaysAllowed } = usePremiumFeatureAllowed(
    LimitKeys.DesktopCalendarFourDays,
    {},
  );
  const { allowed: isCalendarWeekAllowed } = usePremiumFeatureAllowed(
    LimitKeys.DesktopCalendarWeek,
    {},
  );
  const { allowed: isCalendarMonthAllowed } = usePremiumFeatureAllowed(
    LimitKeys.DesktopCalendarMonth,
    {},
  );

  return (
    (userSelectedView === CalendarViewOptions.FourDay &&
      isCalendarFourDaysAllowed &&
      userSelectedView) ||
    (userSelectedView === CalendarViewOptions.Week &&
      isCalendarWeekAllowed &&
      userSelectedView) ||
    (userSelectedView === CalendarViewOptions.Month &&
      isCalendarMonthAllowed &&
      userSelectedView) ||
    undefined
  );
};
